import {Command} from "./Command";
import {GameService} from "../services/game.service";
import {SetDistanceCommand} from "./SetDistanceCommand";
import {DEFAULT_FIRST_DOWN_DISTANCE, DEFAULT_YARD_LINE_TWENTY} from "../helpers/distance";
import {SetDownCommand} from "./SetDownCommand";
import {Down} from "../model/down";
import {SetYardLineCommand} from "./SetYardLineCommand";
import {SetPlayResultCommand} from "./SetPlayResultCommand";
import {PlayResult} from "../model/playResult";

export class SetDeadBallPlay implements Command {
  private commands: Command[] = [];

  constructor(
    private game: GameService,
    public result: PlayResult
  ) { }

  execute() {
    console.log('COMMAND SetDeadBallPlay')

    this.commands.push(
      new SetPlayResultCommand(this.game.getFirstPendingGamePlay(), this.result),
    )

    for (const command of this.commands) {
      command.execute();
    }

    this.game.addCommandsAfterTagging([
      new SetDistanceCommand(this.game.getNextGamePlay(), DEFAULT_FIRST_DOWN_DISTANCE),
      new SetDownCommand(this.game.getNextGamePlay(), Down.D1),
      new SetYardLineCommand(this.game.getNextGamePlay(), DEFAULT_YARD_LINE_TWENTY)
    ])
  }
}
